import { render, staticRenderFns } from "./OpenIcon.vue?vue&type=template&id=534c9225&"
import script from "./OpenIcon.vue?vue&type=script&lang=js&"
export * from "./OpenIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports